'use strict';
import * as $j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dIncoterm$002dLocation$0024 from "./app.data.data_point_types$package$-Incoterm-Location$.js";
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermLocationForm$() {
  this.aKZ = null;
  this.aLc = null;
  this.aL4 = null;
  this.aL5 = false;
  this.aLa = null;
  this.aLb = false;
  this.aL0 = null;
  this.aL1 = false;
  this.aL8 = null;
  this.aL9 = false;
  this.aL6 = null;
  this.aL7 = false;
  this.aL2 = null;
  this.aL3 = false;
  $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermLocationForm$ = this;
  this.aKZ = $j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dIncoterm$002dLocation$0024.$m_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermLocation$();
  this.aLc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_prelude_neotype\uff3fchimney$package$().eU($j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dIncoterm$002dLocation$0024.$m_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermLocation$());
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermLocationForm$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermLocationForm$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermLocationForm$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermLocationForm$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermLocationForm$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermLocationForm$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermLocationForm$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermLocationForm$.prototype = $p;
$p.eR = (function() {
  return this.aKZ;
});
$p.eO = (function() {
  return this.aLc;
});
$p.b9 = (function() {
  if ((!this.aL5)) {
    this.aL4 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$1(this);
    this.aL5 = true;
  }
  return this.aL4;
});
$p.b3 = (function() {
  if ((!this.aLb)) {
    this.aLa = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$5(this);
    this.aLb = true;
  }
  return this.aLa;
});
$p.aG = (function() {
  if ((!this.aL1)) {
    this.aL0 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$6(this);
    this.aL1 = true;
  }
  return this.aL0;
});
$p.az = (function() {
  if ((!this.aL9)) {
    this.aL8 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_UnvalidatedNewtypeOf__partialTransformer__Lio_scalaland_chimney_PartialTransformer(this);
    this.aL9 = true;
  }
  return this.aL8;
});
$p.aY = (function() {
  if ((!this.aL7)) {
    this.aL6 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_utils_Validatable$().eS(this.az());
    this.aL7 = true;
  }
  return this.aL6;
});
$p.bN6 = (function() {
  if ((!this.aL3)) {
    this.aL2 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$$anon$5(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
      var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
      if (((x === null) ? (x$1 === null) : (x === x$1))) {
        return "Incoterm Location";
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    })), $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().cN());
    this.aL3 = true;
  }
  return this.aL2;
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermLocationForm$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermLocationForm$, "app.data.data_point_types$package$IncotermLocationForm$", ({
  FT: 1,
  N: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermLocationForm$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermLocationForm$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermLocationForm$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermLocationForm$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermLocationForm$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermLocationForm$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermLocationForm$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermLocationForm$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermLocationForm$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$IncotermLocationForm$ };
//# sourceMappingURL=app.data.data_point_types$package$-Incoterm-Location-Form$.js.map
